// Modules
import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import compose from 'lodash/flowRight';
import { getLang } from 'redux-pagan';
import cx from 'classnames';
import IntlTelInput from '../../components/IntlTelInput/IntlTelInput';
// Components
import OMInputField from '../../components/OMComponents/OMInputField/OMInputField';
import OMRadioButtons from '../../components/OMComponents/OMRadioButtons/OMRadioButtons';
import ResendLimitExceededMessage from '../../components/ResendLimitExceededMessage/ResendLimitExceededMessage';
import ResendTimerMessage from '../../components/ResendTimerMessage/ResendTimerMessage';
import ResendButton from '../../components/ResendButton/ResendButton';
import AuthorizationButton from '../../components/AuthorizationButton/AuthorizationButton';
import CloudflareCaptcha from '../../components/CloudflareCaptcha/CloudflareCaptcha';
// Redux
import {
  authenticateUser,
  switchAuthModalType,
  openAuthenticationModal,
  checkPhone,
  socialNetworkAuthentication,
  authenticateUserByNumber
} from '../../redux/modules/userAuthentication';
// Helper
import { authenticationModalType, israelCode, PREFERRED_COUNTRIES, userAuthenticationTabs, supportEmail } from '../../constants';
import { emailRegexValidation, phoneRegexValidation, validateAuthPhoneNumber } from '../../utils/validate';
import { formatLoginPhoneNumber } from '../../utils/formatPhoneNumber';
import CAPTCHA_ACTIONS from '../../helpers/captchaConstants';
import { loginType, loginTypeOptions } from './constants';
import validate from './validate';
// Styles
import * as styles from './loginContainer.scss';

class LoginContainer extends Component {
  state = {
    doValidate: false,
    captcha: null,
    countryCode: israelCode,
    emailIsValid: false,
    phoneIsValid: false,
    isFirstValue: false,
    resendCounter: 0,
    timerTimeLeft: 0,
    isTimerRunning: false,
    isResendForm: false,
    isWaitingCaptcha: false,
    isCaptchaRequired: false
  }

  componentDidUpdate(prevProps) {
    const loadingUserData = this.props.userAuthentication.loading;
    const error = get(this.props, 'userAuthentication.error');
    const prevError = get(prevProps, 'userAuthentication.error');

    if (!loadingUserData && prevError !== error && error) {
      this.fetchReCaptchaToken(null);
    }
  }

  componentWillUnmount() {
    clearInterval(this.resendTimer);
  }

  onSelectFlag = (_, countryData) => {
    this.setState({ countryCode: countryData.dialCode });
  };

  setWrapperRef = (node) => {
    this.formRef = node;
  };

  getPhoneInputRef = (ref) => { this.phoneInputRef = ref; }

  forgotPassword = () => {
    this.props.openAuthenticationModal({ bodyType: authenticationModalType.FORGOT_PASSWORD });
  };

  startTimer = () => {
    clearInterval(this.resendTimer);
    this.resendTimer = setInterval(() => {
      this.setState((prevState) => {
        if (prevState.timerTimeLeft <= 1) {
          clearInterval(this.resendTimer);
          return { timerTimeLeft: 0, isTimerRunning: false };
        }
        return { timerTimeLeft: prevState.timerTimeLeft - 1 };
      });
    }, 1000);
  };

  submitLoginViaPassword = (values) => {
    const email = get(values, 'email');
    const password = get(values, 'password');
    this.props.authenticateUser({
      email,
      password,
      requestType: userAuthenticationTabs.SIGN_IN,
      captcha: get(values, 'captcha')
    });
  }

  submitLoginViaSms = (values, isResendForm) => {
    const isCheckPhone =
      this.props.userAuthentication &&
      this.props.userAuthentication.isCheckPhone;
    const phone = get(values, 'phone');
    const code = get(values, 'code');
    const { countryCode } = this.state;

    if (!values.captcha) {
      console.warn('No captcha found');
      return;
    }

    this.setState({ captcha: null });

    const phoneNumberData = formatLoginPhoneNumber(phone, countryCode);

    if (!isCheckPhone) {
      this.props.checkPhone({
        phone: phoneNumberData,
        captcha: values.captcha,
        locale: this.props.locale
      });
      this.setState({
        resendCounter: 0,
        isTimerRunning: true,
        timerTimeLeft: 61
      });
      this.startTimer();
    } else if (isResendForm) {
      this.props.checkPhone({
        phone: phoneNumberData,
        captcha: values.captcha,
        locale: this.props.locale
      });
      this.setState((prevState) => ({
        resendCounter: prevState.resendCounter + 1,
        isTimerRunning: prevState.resendCounter < 3,
        timerTimeLeft: prevState.resendCounter < 3 ? 61 : 0
      }));
      this.startTimer();
    } else if (isCheckPhone) {
      this.props.authenticateUserByNumber({
        phone: phoneNumberData,
        captcha: values.captcha,
        code
      });
    }
    // this.setState({ captcha: null });
  }

  submitForm = (values, isResendForm) => {
    const { captcha } = this.state;

    this.setState({ isResendForm });

    const data = { ...values, captcha };
      if (values.loginType === loginType.LOGIN_VIA_SMS) {
        this.submitLoginViaSms(data, isResendForm);
      } else {
        this.submitLoginViaPassword(data);
      }
  };

  handleSubmit = (evt, isResendForm) => {
    if (this.state.isWaitingCaptcha || this.state.isCaptchaRequired) {
      return;
    }

    this.props.handleSubmit((values) => {
      const submit = () => {
        this.submitForm(values, isResendForm);
      };

      if (this.state.captcha) {
        submit();
        return;
      }

      console.warn('Captcha is missing');
      this.pendingSubmission = submit;
      this.setState({
        isWaitingCaptcha: true
      });
    })(evt);
  };

  fetchReCaptchaToken = (token) => {
    this.setState({
      captcha: token
    });

    if (token && this.pendingSubmission) {
      this.pendingSubmission();
    }

    this.pendingSubmission = null;
  };

  handleCaptchaWaiting = (isWaiting) => {
    this.setState({
      isWaitingCaptcha: isWaiting
    });
  };

   handleCaptchaRequired = (isRequired) => {
    this.setState({
      isCaptchaRequired: isRequired
    });

    if (isRequired) {
      this.pendingSubmission = null;
    }
  };

  validationMark = isInvalid => this.setState({ showError: isInvalid });

  handleSelectCountry = (first, countryData) => {
    if (this.state.countryCode !== countryData.dialCode) {
      this.setState({ countryCode: countryData.dialCode });
    }
  }

  handlePhoneNumberChange = (isValid, inputData, countryData, phoneNumber) => {
    const onlyNums = inputData.replace(/[^+\d\s-]/g, '');

    const condition = onlyNums && (onlyNums.length >= 9 || onlyNums.length <= 11);

    this.props.change('phone', onlyNums);

    this.setState({ phoneIsValid: condition });

    if (this.state.countryCode !== countryData.dialCode) {
      this.setState({ countryCode: countryData.dialCode });
    }
  };

  defineEmailErrorMsg = () => {
    let errorMsg = '';

    if (this.state.isTemporaryEmail) {
      errorMsg = this.props.translate('authenticationPage', 'errorMessageForTemporaryUser');
    } else if (!this.state.emailIsValid) {
      errorMsg = this.props.translate('authenticationPage', 'emailTooltipMessage');
    } else {
      const { error } = this.props.userAuthentication;
      errorMsg = (error && (error.name === 'BadRequestError' || error.message.match(/email/i)))
        ? this.props.translate('authenticationPage', 'errorMessage')
        : '';
    }

    return errorMsg.toString();
  };

  renderButton = () => {
    const loadingUserData = this.props.userAuthentication.loading;
    const error = get(this.props, 'userAuthentication.error');
    const { translate, isNative } = this.props;
    const { captcha, isWaitingCaptcha, isCaptchaRequired } = this.state;
    const showCodeField =
      (this.props.userAuthentication && this.props.userAuthentication.isCheckPhone)
       && !loadingUserData;

    return (
      <div className={styles.buttonWrapper}>

        {!isNative && (
          <CloudflareCaptcha
            fetchToken={this.fetchReCaptchaToken}
            onWaitingChange={this.handleCaptchaWaiting}
            onRequiredCaptcha={this.handleCaptchaRequired}
            action={CAPTCHA_ACTIONS.LOGIN_PASSWORD}
            doReset={(!!error && !loadingUserData) || showCodeField}
          />
        )}
        <AuthorizationButton
          onClick={this.handleSubmit}
          isLoading={loadingUserData || isWaitingCaptcha}
          disabled={isCaptchaRequired}
        >
          {translate('authenticationPage', 'buttonLogin')}
        </AuthorizationButton>
      </div>
    );
  };

  renderResendButton = () => {
    const showCodeField = (this.props.userAuthentication && this.props.userAuthentication.isCheckPhone);
    if (!showCodeField) {
      return null;
    }

    const loadingUserData = (this.props.userAuthentication && this.props.userAuthentication.loading);
    const disabled = this.state.isTimerRunning
      || this.state.resendCounter >= 3
      || loadingUserData
      || !this.state.captcha;

    const { translate } = this.props;
    const { isTimerRunning, resendCounter } = this.state;

    if (resendCounter >= 3) {
      return (
        <ResendLimitExceededMessage className={styles.resendLimitMessage} translate={translate} />
      );
    }
    return (
      <div
        className={styles.resendContentWrapper}
      >
        {resendCounter < 3 && isTimerRunning && (
          <ResendTimerMessage translate={translate} timeLeft={this.state.timerTimeLeft} />
        )}
        <div className={styles.buttonWrapper}>
            <ResendButton
              isLoading={loadingUserData}
              disabled={disabled}
              translate={translate}
              isTimerRunning={isTimerRunning}
              onClick={(evt) => this.handleSubmit(evt, true)}
            />
        </div>
      </div>
    );
  }

  renderPhoneInput = ({ input, meta: { error, touched } }) => (
    <div className={cx(styles.inputPhone, { 'has-error': error && touched })}>
      <IntlTelInput
        ref={this.getPhoneInputRef}
        autoPlaceholder={false}
        isRtl={this.props.isRtl}
        nationalMode={false}
        onSelectFlag={this.onSelectFlag}
        containerClassName={cx('intl-tel-input', styles.countrySelect)}
        inputClassName="form-control phone-input"
        fieldName="phone_number"
        value={input.value}
        preferredCountries={PREFERRED_COUNTRIES}
        onPhoneNumberChange={this.handlePhoneNumberChange}
        useMobileFullscreenDropdown={false}
        separateDialCode
      />
    </div>
  );

  renderEmailInput = () => {
    const handleChange = (evt) => {
      const { value } = evt.target;
      const isEmpty = !value || (value && value.length === 0);
      const trimmedValue = value ? value.replace(/\s/g, '') : '';

      const emailIsValid = emailRegexValidation(trimmedValue);
      const phoneIsValid = phoneRegexValidation(trimmedValue);

      this.setState((prev) => ({
        ...prev,
        isFirstValue: !!value.length,
        emailIsValid: isEmpty ? false : emailIsValid,
        phoneIsValid: isEmpty ? false : phoneIsValid
      }));
    };

    return (
      <div
        className={cx(
          { [styles.phoneInput]: (this.state.phoneIsValid || !this.state.isFirstValue) },
          'form-group'
        )}
        ref={(email) => { this.email = email; }}
      >
        <OMInputField
          isForm
          name="email"
          type="text"
          translate={this.props.translate}
          placeholder={`${this.props.translate('authenticationPage', 'emailFieldPlaceholder')}`}
          title={this.defineEmailErrorMsg()}
          showHoverTooltip={false}
          doValidate={this.state.doValidate}
          isMobile={this.props.isMobile}
          onChange={handleChange}
          isRtl={this.props.isRtl}
          validationMark={this.validationMark}
          showErrorMessageDesktop
        />
      </div>
    );
  }

  renderPasswordInput = () => (
    <div className="form-group">
      <OMInputField
        isForm
        name="password"
        type="password"
        translate={this.props.translate}
        placeholder={`${this.props.translate('authenticationPage', 'passwordFieldPlaceholder')}`}
        title={`${this.props.translate('authenticationPage', 'passwordTitle')}`}
        isMobile={this.props.isMobile}
        hidePasswordTitle={`${this.props.translate('authenticationPage', 'hidePassword')}`}
        revealPasswordTitle={`${this.props.translate('authenticationPage', 'revealPassword')}`}
        isRtl={this.props.isRtl}
        showErrorMessageDesktop
      />
    </div>
  );

  renderPropertyTypes = () => (
    <div className={styles.propTypesBlock}>
      <OMRadioButtons
        name="loginType"
        values={loginTypeOptions.map(item =>
          ({ value: item.name, label: this.props.translate('authenticationPage', item.label) }))}
        className={styles.flexWrap}
      />
    </div>
  );

  renderCodeField = () => {
    const showCodeField = (this.props.userAuthentication && this.props.userAuthentication.isCheckPhone);

    if (!showCodeField) {
      return null;
    }

    return (
      <div className={cx(styles.codeBlock, 'form-group')}>
        <OMInputField
          isForm
          name="code"
          type="text"
          maxLength="6"
          translate={this.props.translate}
          placeholder={`${this.props.translate('authenticationPage', 'tabCode')}`}
          isMobile={this.props.isMobile}
          isRtl={this.props.isRtl}
          validate={value => {
            if (this.state.isResendForm && (!value || !value.length)) {
              return undefined;
            }
            return (value && value.length === 4) ? undefined : 'length-code';
          }}
          validationMark={this.validationMark}
          onChange={(evt) => {
            const value = evt.target.value;
            evt.target.value = value.replace(/[\D]/g, '');
          }}
        />
      </div>
    );
  };

  render() {
    const { translate, fields, isRtl } = this.props;
    const isLoginViaSms = fields.loginType === loginType.LOGIN_VIA_SMS;
    const isLoginViaPassword = fields.loginType === loginType.LOGIN_VIA_PASSWORD;

    return (
      <div className={styles.container}>
        <form
          onSubmit={this.handleSubmit}
          ref={this.setWrapperRef}
        >
          {isLoginViaSms ? (
            <Field
              name="phone"
              type="text"
              translate={translate}
              isRtl={isRtl}
              component={this.renderPhoneInput}
              validate={validateAuthPhoneNumber}
            />
          ) : (
            this.renderEmailInput()
          )}
          {this.renderPropertyTypes()}
          {isLoginViaPassword && this.renderPasswordInput()}
          {isLoginViaPassword && <div className={styles.forgotPassword}>
            <p onClick={this.forgotPassword}>{translate('authenticationPage', 'forgotPassword')}</p>
          </div>}
          {isLoginViaSms && this.renderCodeField()}
          {this.renderButton()}
          {isLoginViaSms && this.renderResendButton()}
          {/* <div className={styles.intervalWrapper}>
            <hr />
            <p>{this.props.translate('saveSearchLocation', 'or')}</p>
            <hr />
          </div>
          {this.renderSocialAuthentication()} */}
        </form>
      </div>
    );
  }
}

LoginContainer.propTypes = {
  translate: PropTypes.func,
  locale: PropTypes.string.isRequired,
  isMobile: PropTypes.bool,
  fields: PropTypes.object,
  userAuthentication: PropTypes.object,
  sendContactUsForm: PropTypes.func,
  openMessageModal: PropTypes.func,
  hideMessageModal: PropTypes.func,
  switchAuthModalType: PropTypes.func,
  userData: PropTypes.object,
  isMessageModalOpen: PropTypes.bool,
  validatePassword: PropTypes.func,
  usage: PropTypes.string,
  isRtl: PropTypes.bool,
  isNative: PropTypes.bool,
  isContactUsModalOpen: PropTypes.bool,
  hideContactUsModal: PropTypes.func,
  authenticateUser: PropTypes.func,
  openAuthenticationModal: PropTypes.func,
  socialNetworkAuthentication: PropTypes.func,
  change: PropTypes.func,
  authenticateUserByNumber: PropTypes.func,
  handleSubmit: PropTypes.func,
  checkPhone: PropTypes.func,
  isPageForRealtor: PropTypes.bool
};

const selector = formValueSelector('loginForm');

const mapStateToProps = state => ({
  translate: getLang(state.lang, 'static'),
  locale: state.lang.locale,
  isMobile: state.windowDimentions.isMobile,
  userData: state.userAuthentication.data,
  userAuthentication: state.userAuthentication,
  fields: {
    email: selector(state, 'email'),
    phone: selector(state, 'phone'),
    password: selector(state, 'password'),
    loginType: selector(state, 'loginType')
  },
  initialValues: {
    loginType: loginType.LOGIN_VIA_PASSWORD
  }
});

const mapDispatchToProps = {
  authenticateUser,
  switchAuthModalType,
  openAuthenticationModal,
  checkPhone,
  socialNetworkAuthentication,
  authenticateUserByNumber
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'loginForm',
    validate
  })
)(LoginContainer);
